
import { Injectable } from '@angular/core';
import { ApplicationHttpClient } from 'app/application-http-client';
import { BankApprovalPushLog } from 'app/modules/desking/push/bank-approval-push-log.model';
import { Observable } from 'rxjs';

@Injectable()
export class CudlConnectService {
  private apiUrl = '/push/cudlconnect';

  public push(params: Object): Observable<any> {
    return this.http.post(this.apiUrl, params);
  }

  public getHistory(scenarioId: number): Observable<Array<BankApprovalPushLog>> {
    const params = ApplicationHttpClient.toHttpParams({
      scenarioId: scenarioId
    });

    return this.http.get(this.apiUrl, { params: params, errorNotification: true });
  }

  constructor(private http: ApplicationHttpClient) {}
}
